import { render, staticRenderFns } from "./PoliticaPrivacidadeColaboradores.vue?vue&type=template&id=9b049934&scoped=true&"
import script from "./PoliticaPrivacidadeColaboradores.vue?vue&type=script&lang=js&"
export * from "./PoliticaPrivacidadeColaboradores.vue?vue&type=script&lang=js&"
import style0 from "./PoliticaPrivacidadeColaboradores.vue?vue&type=style&index=0&id=9b049934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b049934",
  null
  
)

export default component.exports